module.exports = __webpack_public_path__ + "static/media/finding-us-01.cb79d759.png";